import { createSlice } from '@reduxjs/toolkit'
import { fetchAmountUnit, fetchSymbolGroup } from '../thunks/symbolGroup'

export const symbolGroupUnitSlice = createSlice({
    name: 'groupUnit',
    initialState: {
        group: [],
        unit: []
    },
    reducers: {
        setGroupData: (state, action) => {
            state.group = action.payload
        },
        setUnitData: (state, action) => {
            state.unit = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSymbolGroup.fulfilled,(state,action) => {
            state.group = action.payload
        })
        .addCase(fetchAmountUnit.fulfilled,(state,action) => {
            state.unit = action.payload
        })
    }
})
export const { setGroupData,setUnitData } = symbolGroupUnitSlice.actions
export default symbolGroupUnitSlice.reducer